import { useMemo } from 'react';
import useColorScheme from './useColorScheme';
import { useEnforcedColorScheme } from './EnforcedColorSchemeContext';
const useStyles = function useStyles(styleSet) {
    const colorScheme = useColorScheme();
    const enforcedColorScheme = useEnforcedColorScheme();
    const effectiveScheme = enforcedColorScheme ?? colorScheme;
    return useMemo(() => (effectiveScheme === 'dark' ? styleSet.night : styleSet.day), [effectiveScheme, styleSet]);
};
/**
 * WARNING: This function doesn’t perform any feature flag logic and should only be used inside of navigationOptions callback.
 * @param styleSet The styles generated by `createStyleSheets` utility
 * @param colorScheme The `theme` argument from navigation options
 * @returns Correct styles for set color scheme.
 */
export function getStylesForTheme(styleSet, colorScheme) {
    return colorScheme === 'dark' ? styleSet.night : styleSet.day;
}
export default useStyles;
